import './index.scss';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Feedback from '../../containers/rating-form';
import Modal from '../../containers/modal';

class FeedbackPage extends Component {
  renderContent = () => {
    const {
      theme,
      orderID,
      data,
      closeRating,
      fromTickets,
      FeedbackApiV2,
      callUpdateFeedbackApi,
      getFeedbackApiV2,
      from,
      getOrderHistoryData
    } = this.props;
    // console.log(getFeedbackApiV2, 'data', FeedbackApiV2);
    const dom = (
      <Feedback
        from={from}
        getOrderHistoryData={getOrderHistoryData}
        closeRating={closeRating}
        fromTickets={fromTickets}
        onCloseHandler={this.onCloseModalHandler}
        theme={theme}
        FeedbackApiV2={!FeedbackApiV2 ? getFeedbackApiV2 : FeedbackApiV2}
        callUpdateFeedbackApi={callUpdateFeedbackApi}
        orderID={orderID}
        data={data}
      />
    );
    return dom;
  };

  onCloseModalHandler = () => {
    const { onCloseModalHandler } = this.props;
    onCloseModalHandler();
  };

  render() {
    const { theme } = this.props;
    return (
      <Modal
        isMobileFullLayout
        onCloseHandler={this.onCloseModalHandler}
        hideClose
        // isMobileFullLayout={true}
        fullWidth
      >
        <div className={`feedback ${theme}`}>{this.renderContent()}</div>
      </Modal>
    );
  }
}

FeedbackPage.propTypes = {
  theme: PropTypes.string
};

FeedbackPage.defaultProps = {
  theme: ''
};

export default withRouter(FeedbackPage);
